'use client';

import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { AccordionRow } from './AccordionRow';
import styles from './styles.module.css';
import { renderAccordionContent } from './utils/renderAccordionContent';

import { Container } from '@/components/Container';

export type AccordionItemConfig = {
  titleKey: string;
  contentKey: string;
  linkUrl?: string;
};

type Props = {
  title: string;
  data: AccordionItemConfig[];
  translationNamespace: string;
};

export function Accordion({ title, data, translationNamespace }: Props) {
  const t = useTranslations(translationNamespace);

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <Heading className={styles.accordionTitle}>{title}</Heading>
        <div>
          {data.map(
            ({ titleKey, contentKey, linkUrl }: AccordionItemConfig) => (
              <AccordionRow
                key={titleKey}
                title={t(titleKey)}
                content={renderAccordionContent({
                  t,
                  contentKey,
                  linkUrl,
                })}
              />
            )
          )}
        </div>
      </Container>
    </section>
  );
}
